import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";

const TITLE = "Thiia — CRM et prospection IA sans abonnement pour indépendants";
const DESC =
  "Indépendants, coachs, consultants et TPE : Thiia trouve vos clients, rédige vos relances et suit vos contacts. Packs de crédits à 29, 59 ou 99 €, sans abonnement. Données en Europe.";

export const Route = createFileRoute("/landing")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://thiia.app/" },
      { property: "og:image", content: "https://thiia.app/og-image.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://thiia.app/og-image.jpg" },
    ],
    links: [{ rel: "canonical", href: "https://thiia.app/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "Thiia",
          url: "https://thiia.app/",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, iOS, Android",
          inLanguage: ["fr", "en"],
          description: DESC,
          audience: {
            "@type": "BusinessAudience",
            audienceType: "Indépendants, coachs, consultants, dirigeants de TPE",
          },
          featureList: [
            "Recherche automatique de prospects",
            "CRM simple et suivi des contacts",
            "Rédaction et relance d'emails",
            "Agenda et prise de rendez-vous",
            "Rattachement des justificatifs bancaires",
            "Conformité RGPD et hébergement européen",
          ],
          offers: [29, 59, 99].map((price) => ({
            "@type": "Offer",
            price: String(price),
            priceCurrency: "EUR",
            category: "Pack de crédits, achat unique sans abonnement",
            url: "https://thiia.app/pricing",
          })),
          publisher: { "@type": "Organization", name: "KREAPP", url: "https://thiia.app/" },
        }),
      },
    ],
  }),
  component: LandingPage,
});
